// chakra imports
import { isSafeString } from '@/components/form/schema/common';
import ErrorMessage from '@/components/inputs/ErrorMessage';
import Label from '@/components/inputs/Label';
import useLanguage from '@/utils/hooks/useLanguage';
import { debounce } from 'lodash';
import { ChangeEvent, memo, useEffect, useMemo, useState } from 'react';
import { MdSearch } from 'react-icons/md';

interface SearchFilterProps {
    filter: string;
    setFilter: any;
    label?: string;
}

const SearchFilter = ({ filter, setFilter, label = 'General Search' }: SearchFilterProps) => {
    const lang = useLanguage();

    const [value, setValue] = useState(filter);
    const [error, setError] = useState({ message: '' });
    const onChange = useMemo(() => debounce(setFilter, 500), [setFilter]);

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        if (isSafeString(value)) setError({ message: '' });
        else {
            return;
        }

        if (onChange) {
            setValue(e.target.value);
            onChange(e.target.value);
        }
    };

    useEffect(() => {
        if (!filter) setValue('');
    }, [filter]);

    return (
        <div className="flex items-center gap-2 h-[34px] text-xs">
            <Label className="sm:min-w-32" label={lang.blotters.generalSearch} />
            <div className="relative h-full">
                <div className="absolute left-2 h-full flex justify-center items-center">
                    <MdSearch className="h-4 w-4 text-brand-neutral-200" />
                </div>
                <input
                    value={value}
                    placeholder={`${lang.common.search}...`}
                    className="h-full bg-transparent border border-brand-neutral-700 hover:border-brand-neutral-600 p-1 pl-7 text-brand-neutral-200 placeholder:text-brand-neutral-400 rounded-md"
                    onChange={handleChange}
                />
                <ErrorMessage error={error} />
            </div>
        </div>
    );
};

export default memo(SearchFilter);
